import { useEffect, useRef } from "react";
import { useLanguage } from "../i18n/LanguageContext";

import "./css/LandingPage.css";
import { useIsMobile } from "../hooks/use-mobile";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Organization_LinksClient } from "../web-api-client";
import { useSessionStorageState } from "../hooks/useSessionStorageState";
import { HeroSection } from "../components/landing/HeroSection";
import { DoctorSection } from "../components/landing/DoctorSection";
import { WhyChooseUsSection } from "../components/landing/WhyChooseUs";
import { FacilitiesSection } from "../components/landing/FacilitiesSection";
import { useDoctors } from "../hooks/useDoctors";
import { appConfig } from "../appconfig";
import { fetchWithTimeout } from "../utils/fetchWithTimeout";

const LandingPage = () => {
  const [isMobile] = useIsMobile();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const [orgToken, setOrgToken] = useSessionStorageState<string | null>(
    "orgLinkContext",
    null
  );
  
  const { doctors, isFetching, isError, avatars, avatarErrors } = useDoctors({
    date: "",
    specialty: null,
    availableOnly: false,
    searchTerm: "",
  });

  const resolvingRef = useRef<string | null>(null);
  
  useEffect(() => {
    document.body.style.backgroundColor = "";

    return () => {
      // document.body.style.backgroundColor = "#ddf1dd";
      document.body.style.backgroundColor = "hsl(144deg 48.39% 93.92%)";
    };
  }, []);

  useEffect(() => {
    document.title = t("trangchu");
  }, [t]);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) return;

    if (orgToken === token) {
      return;
    }

    if (resolvingRef.current === token) return;
    resolvingRef.current = token;

    let cancelled = false;

    (async () => {
      try {
        const client = new Organization_LinksClient(appConfig.apiBaseUrl, {
          fetch: fetchWithTimeout()
        }); 
        const res = await client.getApiOrganizationLinkResolve(token);

        if (cancelled) return;

        setOrgToken(token);

      } catch (e) {
        console.error("Resolve organization link failed:", e);
      } finally {
        if (!cancelled) resolvingRef.current = null;
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  if (isMobile === undefined) return;


  return (
    <div className="min-h-screen overflow-hidden">
      <HeroSection isMobile={isMobile} />
      <WhyChooseUsSection isMobile={isMobile}/>
      <DoctorSection doctorSchedules={doctors}/>
      <FacilitiesSection isMobile={isMobile} />
    </div>
  );
};

export default LandingPage;
